function Spinner({ className = '', spinnerClassName }: { className?: string; spinnerClassName?: string }) {
  return (
    <div className={`${className} flex items-center justify-center`}>
      <div className={`w-5 h-5 border-b-[3px] rounded-full ${spinnerClassName} animate-spin`}></div>
    </div>
  );
}

export default Spinner;
